@if (warningMessage && !isAdminApp) {
  <div class="preferences-warning caption">
    <span class="icon-alert error-600-text"></span> {{ warningMessage }}
  </div>
}
